import React from "react";
import {
  Container,
  Row,
  Col,
  Dropdown,
  Form,
  Button,
  Card,
  Accordion,
} from "react-bootstrap";
import {
  object_equals,
  deleteProduct,
  insertProduct,
  validateData,
  updateProduct,
  uploadObjectS3,
  updateS3FileName,
} from "../../../../helper";
import { useEffect } from "react";
import ChooseImage from "../ChooseImage";
import {
  getImagePreview,
  productPackagingDropDown,
  allPackaging,
  defaultProductPackaging,
  getCategoryDropdown,
  getSubCategoryDropDown,
} from "../../../../components/helper";
import ToggleButton from "../../../../components/ToggleButton/index";
import { useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import SelectableContext from "react-bootstrap/SelectableContext";
import Scroll from "react-scroll";
import "./styles.scss";

export default function ProductRow(props) {
  const {
    product,
    categories,
    deteleEmptyProduct,
    fetchProducts,
    subCategories,
    addSubCategory,
    searchString,
    searchCategoryFilter,
    activePageNo,
    setProducts,
    products,
  } = props;

  const [categoryId, setCategoryId] = useState(product.category_id);
  const [name, setName] = useState(product.product_name);
  const [productDesc, setProductDesc] = useState(product.product_desc);
  const [hsn, setHsn] = useState(product.hsn);
  const [dieticianChoice, setDieticianChoice] = useState(
    product.dietician_choice
  );
  const [luxuryGrade, setLuxuryGrade] = useState(product.luxury_grade);
  const [popularChoide, setPopularChoice] = useState(product.popular_choice);
  const [height, setHeight] = useState(product.height);
  const [width, setWidth] = useState(product.width);
  const [length, setLength] = useState(product.length);
  const [weight, setWeight] = useState(product.weight);
  const [listingStatus, setListingStatus] = useState(product.listing_status);
  const [priceFixed, setPriceFixed] = useState(product.price_fixed);
  const [unit, setUnit] = useState(product.unit);
  const [tax, setTax] = useState(product.tax);
  const [mrp, setMrp] = useState(product.mrp);
  const [brand, setBrand] = useState(product.brand);
  const [subCategory, setSubCategory] = useState(product.sub_category);
  const [rateAmount, setRateAmount] = useState(product.rate_amt);
  const [sku, setSku] = useState(product.sku);
  const [courierSVC, setCourierSVC] = useState(product.courier_svc);
  const [productPackaging, setProductPackaging] = useState(
    product.product_packaging
  );
  const [defaultPackaging, setDefaultPackaging] = useState(
    product.default_packaging
  );
  const [imageGallery, setImageGallery] = useState(product.image_gallery);
  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [changeImage, setChangeImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [showSubCategoryInput, setShowSubCategoryInput] = useState(false);
  const [subCategoryInput, setSubCategoryInput] = useState(null);

  const updatedProduct = {
    product_id: product.product_id,
    product_name: name,
    product_desc: productDesc,
    hsn,
    dietician_choice: dieticianChoice,
    luxury_grade: luxuryGrade,
    popular_choice: popularChoide,
    height,
    width,
    length,
    listing_status: listingStatus,
    price_fixed: priceFixed,
    unit,
    tax,
    mrp,
    brand,
    sub_category: subCategory,
    rate_amt: rateAmount,
    sku,
    courier_svc: courierSVC,
    pickup_svc: product.pickup_svc,
    product_packaging: productPackaging,
    default_packaging: defaultPackaging,
    category_id: categoryId,
    weight,
    image_gallery: imageGallery,
    image_src: `products/${
      name ? name.toLowerCase().replace(/ /g, "_") : ""
    }.jpg`,
  };

  useEffect(() => {
    setUpdateEnabled(!object_equals(props.product, updatedProduct));
  }, [updatedProduct, props.product]);

  const handleInsertProduct = () => {
    const validate = validateData(updatedProduct);
    if (validate) {
      let data = Object.assign({}, updatedProduct);
      delete data.product_id;
      insertProduct(data).then(
        async (result) =>
          result &&
          (await fetchProducts(
            searchString,
            searchCategoryFilter,
            activePageNo
          ))
      );
    }
  };

  const handleUpdateProduct = () => {
    const validate = validateData(updatedProduct);
    if (validate) {
      let data = Object.assign({}, updatedProduct);
      delete data.product_id;
      updateProduct(product.product_id, data).then(async (result) => {
        if (result) {
          if (product.product_name !== data.product_name) {
            await updateS3FileName(product.image_src, data.image_src);
          }
          await fetchProducts(searchString, searchCategoryFilter, activePageNo);
        }
      });
    }
  };

  function handleAddProductPackaging(element) {
    var newProductPackaging = Object.assign([], productPackaging);
    if (newProductPackaging === null) {
      newProductPackaging = [];
    }
    newProductPackaging.push(element);
    setProductPackaging(newProductPackaging);
  }

  function handleDeleteProductPackaging(element) {
    var newProductPackaging = Object.assign([], productPackaging);
    const deleteItemIndex = newProductPackaging.indexOf(element);
    if (deleteItemIndex > -1) {
      newProductPackaging.splice(deleteItemIndex, 1);
    }
    if (newProductPackaging.length === 0) {
      setProductPackaging(null);
      setDefaultPackaging(null);
    } else {
      if (element === defaultPackaging) {
        setDefaultPackaging(null);
      }
      setProductPackaging(newProductPackaging);
    }
  }

  const getUnitDropdown = () => (
    <SelectableContext.Provider value={false}>
      <Dropdown>
        <Dropdown.Toggle>{unit || "Choose A Quantity Unit"}</Dropdown.Toggle>
        <Dropdown.Menu>
          {["None", "GMS", "ML", "PCS", "KGS", "KG", "GM", "PC", "L"].map(
            (element, index) => (
              <Dropdown.Item
                key={element + "-" + index}
                eventKey={element}
                onClick={(event) => {
                  if (element === "None") {
                    setUnit(null);
                  } else {
                    setUnit(element);
                  }
                }}
                active={unit === element}
              >
                {element}
              </Dropdown.Item>
            )
          )}
        </Dropdown.Menu>
      </Dropdown>
    </SelectableContext.Provider>
  );

  return (
    <div className="d-flex justify-content-around">
      <Card className="w-100">
        <Accordion.Toggle
          as={Card.Header}
          variant="link"
          eventKey={product.product_id ? product.product_id : "add-new-product"}
        >
          {product.product_id ? product.product_name : "Add A New Product"}
        </Accordion.Toggle>
        <Accordion.Collapse
          eventKey={product.product_id ? product.product_id : "add-new-product"}
        >
          <Card.Body>
            <Container className="w-100 admin-product">
              <Row className="d-flex justify-content-center mb-4">
                <Col>
                  <h4> {product.product_id || "Add New Product"}</h4>
                </Col>
                <Col>
                  <Form.Label>Category</Form.Label>
                  {getCategoryDropdown(
                    categories || [],
                    categoryId,
                    (element) => setCategoryId(element.category_id)
                  )}
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control
                      value={name}
                      required
                      onChange={(event) =>
                        setName(
                          event.target.value === "" ? null : event.target.value
                        )
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex">
                  <Form.Group>
                    <Form.Label>SKU</Form.Label>
                    <Form.Control
                      value={sku}
                      onChange={(event) => setSku(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Brand</Form.Label>
                    <Form.Control
                      value={brand}
                      onChange={(event) => setBrand(event.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group>
                    <Form.Label>Product Description</Form.Label>
                    <Form.Control
                      value={productDesc}
                      onChange={(event) => setProductDesc(event.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Label>Product Sub Category</Form.Label>
                  <div className="sub-category-dropdown">
                    {getSubCategoryDropDown(
                      subCategories,
                      subCategory,
                      (element) => setSubCategory(element)
                    )}
                  </div>
                  <div>
                    <div className="d-flex justify-content-between mt-2 mb-4">
                      {showSubCategoryInput && (
                        <Form.Group className="w-50">
                          <Form.Control
                            placeholder="Add New Sub Category"
                            value={subCategoryInput}
                            onChange={(event) =>
                              setSubCategoryInput(
                                event.target.value === ""
                                  ? null
                                  : event.target.value
                              )
                            }
                          />
                        </Form.Group>
                      )}
                      <Button
                        onClick={() => {
                          if (showSubCategoryInput) {
                            if (subCategoryInput) {
                              if (!subCategories.includes(subCategoryInput)) {
                                addSubCategory(subCategoryInput);
                                setShowSubCategoryInput(false);
                                setSubCategoryInput(null);
                              } else {
                                alert("Sub category already present");
                              }
                            } else {
                              alert("Sub category input empty");
                            }
                          } else {
                            setShowSubCategoryInput(true);
                          }
                        }}
                      >
                        {showSubCategoryInput
                          ? "Confirm"
                          : "Add New Sub Category"}
                      </Button>
                      {showSubCategoryInput && (
                        <Button
                          onClick={() => {
                            setShowSubCategoryInput(false);
                            setSubCategoryInput(null);
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label>Is Luxury Grade</Form.Label>
                  <ToggleButton
                    secondLabel="Yes"
                    firstLabel="No"
                    checkedValue={luxuryGrade}
                    handleOnChange={() => setLuxuryGrade(!luxuryGrade)}
                  />
                </Col>
                <Col>
                  <Form.Label>Is Popular Choice</Form.Label>
                  <ToggleButton
                    secondLabel="Yes"
                    firstLabel="No"
                    checkedValue={popularChoide}
                    handleOnChange={() => setPopularChoice(!popularChoide)}
                  />
                </Col>
                <Col>
                  <Form.Label>Is Dietician Choice</Form.Label>
                  <ToggleButton
                    secondLabel="Yes"
                    firstLabel="No"
                    checkedValue={dieticianChoice}
                    handleOnChange={() => setDieticianChoice(!dieticianChoice)}
                  />
                </Col>
                <Col>
                  <Form.Label>Listing Status</Form.Label>
                  <ToggleButton
                    secondLabel="Live"
                    firstLabel="Not Live"
                    checkedValue={listingStatus}
                    handleOnChange={() => setListingStatus(!listingStatus)}
                  />
                </Col>
                <Col>
                  <Form.Label>Image Gallery</Form.Label>
                  <ToggleButton
                    secondLabel="Yes"
                    firstLabel="No"
                    checkedValue={imageGallery}
                    handleOnChange={() => setImageGallery(!imageGallery)}
                  />
                </Col>
                <Col>
                  <Form.Label>Courier SVC</Form.Label>
                  <ToggleButton
                    secondLabel="Yes"
                    firstLabel="No"
                    checkedValue={courierSVC}
                    handleOnChange={() => setCourierSVC(!courierSVC)}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Length</Form.Label>
                    <Form.Control
                      type="number"
                      value={length}
                      onChange={(event) =>
                        setLength(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Height</Form.Label>
                    <Form.Control
                      type="number"
                      value={height}
                      onChange={(event) =>
                        setHeight(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Width</Form.Label>
                    <Form.Control
                      type="number"
                      value={width}
                      onChange={(event) =>
                        setWidth(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Weight/No Units</Form.Label>
                    <Form.Control
                      type="number"
                      value={weight}
                      required
                      onChange={(event) =>
                        setWeight(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Units</Form.Label>
                    {getUnitDropdown()}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>HSN</Form.Label>
                    <Form.Control
                      type="text"
                      value={hsn}
                      required
                      onChange={(event) =>
                        setHsn(
                          event.target.value === "" ? null : event.target.value
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Price Fixed</Form.Label>
                    <Form.Control
                      type="number"
                      disabled={rateAmount !== null}
                      value={priceFixed}
                      required
                      onChange={(event) =>
                        setPriceFixed(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Tax %</Form.Label>
                    <Form.Control
                      type="number"
                      value={tax}
                      required
                      onChange={(event) =>
                        setTax(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Rate Amount</Form.Label>
                    <Form.Control
                      type="number"
                      disabled={priceFixed !== null}
                      value={rateAmount}
                      onChange={(event) =>
                        setRateAmount(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>MRP</Form.Label>
                    <Form.Control
                      type="number"
                      value={mrp}
                      required
                      onChange={(event) =>
                        setMrp(
                          event.target.value === ""
                            ? null
                            : Number(event.target.value)
                        )
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              {!priceFixed > 0 && (
                <Row className="mb-5">
                  <Col>{allPackaging(handleAddProductPackaging)}</Col>
                  <Col>
                    {productPackagingDropDown(productPackaging, (element) => {
                      handleDeleteProductPackaging(element);
                    })}
                  </Col>
                  <Col>
                    {defaultProductPackaging(
                      defaultPackaging,
                      productPackaging,
                      (element) => setDefaultPackaging(element)
                    )}
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <Button
                    disabled={!updateEnabled && !imageFile}
                    onClick={async () => {
                      product.product_id
                        ? handleUpdateProduct()
                        : handleInsertProduct();
                      if (imageFile) {
                        await uploadObjectS3(product.image_src, imageFile).then(
                          () => {
                            setImageFile(null);
                            setChangeImage(false);
                            setUpdateImage(true);
                          }
                        );
                      }
                    }}
                  >
                    {product.product_id ? "Update" : "Insert"}
                  </Button>
                </Col>
                {product.product_id && (
                  <Col>
                    <Button
                      onClick={() => {
                        const duplicateProduct = Object.assign(
                          {},
                          updatedProduct
                        );
                        delete duplicateProduct.product_id;
                        const newProducts = Object.assign([], products);
                        newProducts.push(duplicateProduct);
                        setProducts(newProducts);
                        alert("The product has been duplicated.");
                        Scroll.animateScroll.scrollToBottom();
                      }}
                    >
                      Duplicate Product
                    </Button>
                  </Col>
                )}
                <Col>
                  <FaTrashAlt
                    className="ml-1"
                    size={25}
                    onClick={() => {
                      product.product_id
                        ? deleteProduct(
                            product.product_id,
                            product.product_name
                          ).then(async (result) =>
                            result
                              ? await fetchProducts(
                                  searchString,
                                  searchCategoryFilter,
                                  activePageNo
                                )
                              : null
                          )
                        : deteleEmptyProduct();
                    }}
                  />
                </Col>
                <Col sm={2} className="d-flex mr-3">
                  <Col>
                    {getImagePreview(imageFile, product.image_src, updateImage)}
                  </Col>
                  <Col>
                    <Button onClick={() => setChangeImage(!changeImage)}>
                      {`${
                        product.image_src === null && imageFile === null
                          ? "Add"
                          : "Change"
                      } Image`}
                    </Button>
                  </Col>
                  {imageFile && (
                    <Col>
                      <Button onClick={() => setImageFile(null)}>
                        Cancel Image
                      </Button>
                    </Col>
                  )}
                </Col>
              </Row>
            </Container>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <ChooseImage
        show={changeImage}
        setImageFile={setImageFile}
        imageFile={imageFile}
        onClose={() => setChangeImage(false)}
      />
    </div>
  );
}
